import DuvidasFrequentes from '../components/templates/DuvidasFrequentes';

export default function DuvidasFrequentesPage() {
  return <DuvidasFrequentes />;
}
